import {IToJson} from '@toolify/client/src/types/IToJson'
import {IDatabaseItemLocationPoint} from '@toolify/server/src/services/LocationClusteringService/types/IDatabaseItemLocationPoint'
import {mapDatabaseItemResponseInstance} from '@toolify/client/src/modules/api/singletons/mapDatabaseItemResponseInstance'

export function mapClusters(clusters: IToJson<IDatabaseItemLocationPoint>[]): IDatabaseItemLocationPoint[] {
  return clusters.map((cluster) => {
    return {
      ...cluster,
      properties: {
        ...cluster.properties,
        databaseItem: cluster.properties.databaseItem ? mapDatabaseItemResponseInstance(cluster.properties.databaseItem) : null,
      },
    }
  })
}
